import type { HTMLAttributes, ReactNode } from 'react'
import { Card } from '../card/Card.tsx'
import { Text } from '../text/Text.tsx'
import styles from './FeatureCard.module.css'

export type FeatureCardSize = 'default' | 'lg'

export interface FeatureCardProps extends HTMLAttributes<HTMLDivElement> {
  icon: ReactNode
  title: string
  description?: ReactNode
  accent?: string
  size?: FeatureCardSize
  gradientBorder?: boolean
  children?: ReactNode
}

export function FeatureCard({
  icon,
  title,
  description,
  accent,
  size = 'default',
  gradientBorder,
  children,
  className,
  style,
  ...props
}: FeatureCardProps) {
  const isLg = size === 'lg'

  const classes = [
    styles.featureCard,
    isLg && styles.lg,
    className,
  ].filter(Boolean).join(' ')

  return (
    <Card
      interactive
      accent={accent}
      gradientBorder={gradientBorder}
      padding={isLg ? 'xl' : 'lg'}
      className={classes}
      style={style}
      {...props}
    >
      <div className={styles.content}>
        <div className={styles.iconWrap}>
          {icon}
        </div>
        <Text as="h3" size={isLg ? 'xl' : 'lg'} weight="semibold">
          {title}
        </Text>
        {description && (
          typeof description === 'string'
            ? <Text size={isLg ? 'base' : 'sm'} muted>{description}</Text>
            : description
        )}
        {children && <div className={styles.body}>{children}</div>}
      </div>
    </Card>
  )
}
